import React, { useEffect, useState } from "react";
import SiteSubcompanyTable from "./SubCompany";
import Dashboardnavbar from "../../layout/Navbar/Navbar";
import SiteDepartmentTable from "./Department";
const SubCompanymain = () => {

    const [toggleState, setToggleState] = useState(1);

    const getSelectedTitle = () => {
        switch (toggleState) {
            case 1:
                return "Sub Company";

            case 2:
                return "Department";
            default:
                return "Sub Company";
        }
    };
    return (
        <>

            <Dashboardnavbar url="Sub Company" name={getSelectedTitle()} />
            <div className="content-tabs ">
                <div
                    className="toggle-button-area flex-row justify-between"
                    style={{ padding: "15px 30px" }}
                >
                    <div>
                        <button
                            className={
                                toggleState === 1
                                    ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                                    : "dashboardcomponent-tabs  font-weight400  font-size-subheading  "
                            }
                            onClick={() => setToggleState(1)}
                        >
                            Sub Company
                        </button>

                        <button
                            className={
                                toggleState === 2
                                    ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs"
                                    : "dashboardcomponent-tabs  font-weight400  font-size-subheading  "
                            }
                            onClick={() => setToggleState(2)}
                        >
                            Department
                        </button>
                    </div>

                </div>
            </div>
            <>
                {toggleState === 1 ? <SiteSubcompanyTable /> : null}
                {toggleState === 2 ? <SiteDepartmentTable /> : null}


            </>

        </>
    );
};


export default SubCompanymain